import React from "react";

import { ColumnDef } from "@tanstack/react-table";
import { XIcon } from "lucide-react";

import {
  embeddingStatusColumn,
  enrichmentStatusColumn,
} from "@/components/common/status-columns";
import { EditButton } from "@/components/refine-ui/buttons/edit";
import { makeTooltip } from "@/components/ui/tooltip";
import { IGenreData } from "@/types/genre";

export const useGenreColumns = () => {
  const columns = React.useMemo<ColumnDef<IGenreData>[]>(
    () => [
      {
        id: "id",
        accessorKey: "document.id",
        header: "ID",
      },
      {
        id: "name",
        // accessorKey: "document.name",
        accessorFn: (row) =>
          row.highlights.filter((h: any) => h.field === "name")[0]?.snippet ??
          row.document.name,
        header: "Name",
        minSize: 200,
        cell: function render({ getValue }: any) {
          return makeTooltip(
            <div
              className="truncate"
              dangerouslySetInnerHTML={{ __html: getValue() }}
            ></div>,
          );
        },
        enableSorting: true,
        size: 300,
      },
      {
        id: "deprecated",
        accessorKey: "document.deprecated",
        header: "Deprecated",
        minSize: 120,
        cell: function render({ getValue }: any) {
          return getValue() ? "Yes" : "No";
        },
        enableSorting: false,
        size: 120,
      },
      // `/genres` used to have NO enrichment column at all, despite genre being
      // one of the nine enriched *and* four embeddable types. There
      // is no `status` column on this list, so the pair goes in the equivalent
      // early-middle slot — right after `deprecated`, never out by `actions`.
      enrichmentStatusColumn<IGenreData>(),
      embeddingStatusColumn<IGenreData>(),
      {
        id: "source",
        accessorKey: "document.metadata.source",
        header: "Source",
        cell: ({ getValue }) => {
          return getValue() ? (
            <img
              className="h-6 w-6 bg-foreground rounded-full text-green-600 ml-4"
              src="https://www.svgrepo.com/show/333603/spotify.svg"
            />
          ) : (
            <XIcon className="text-red-700 ml-4" />
          );
        },
        size: 80,
        enableColumnFilter: false,
        enableHiding: false,
        enableSorting: false,
      },
      {
        id: "actions",
        header: "Actions",
        cell: function render({ row }) {
          return (
            <EditButton
              size="sm"
              hideText={true}
              recordItemId={row.original.document.id}
            />
          );
        },
        enableSorting: false,
        enablePinning: true,
        size: 100,
      },
    ],
    [],
  );
  return columns;
};
